module.exports = __webpack_public_path__ + "static/media/store-huawei.30a5b2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store-huawei.png
// module id = 101
// module chunks = 0